import { isSchemaNotBoolean as h, isObjectType as u } from "./types.js";
import { a as f, s as m } from "../../set-CmOi9Z8k.js";
import { g as c } from "../../_commonjsHelpers-B52_cu2H.js";
import { g as d } from "../../get-BqrHaTdZ.js";
import { u as l } from "../../uniq-uUhGQWTe.js";
var y = f();
const n = /* @__PURE__ */ c(y);
class N {
  constructor(r) {
    this.schema = r;
  }
  getPropertySchema(r) {
    return n(r).reduce((t, e) => {
      var i, p;
      if (t.type === "object" && ((i = t == null ? void 0 : t.properties) != null && i[e])) {
        const o = t.properties[e];
        if (h(o))
          return o;
      }
      if (t.type === "array" && !Array.isArray(t.items)) {
        const o = t.items;
        if (u(o) && ((p = o.properties) != null && p[e])) {
          const a = o.properties[e];
          if (h(a))
            return a;
        }
      }
      return t;
    }, this.schema);
  }
  updatePropertySchema(r, s) {
    this.schema = m(`properties.${r}`, s, this.schema);
  }
  addPropertyToRequired(r) {
    const s = n(r), t = s[s.length - 1], e = s.slice(0, -1).concat(["required"]), i = d(this.schema, e) ?? [];
    this.schema = m(
      e,
      l([...i, t]),
      this.schema
    );
  }
}
export {
  N as JSONSchemaHandler
};
